class BxfFormItemConstants {
    static STRING = {
        CONTAINER: 'bxf-form-item__container',
        SUFFIX_SLOT: 'bxf-form-item__suffix-slot',
    };
}

export { BxfFormItemConstants as B };
